
import AppCalendar from "@/components/calendar/Calendar.vue";
import AppCalendarList from "@/components/calendar/CalendarList.vue";
import AppBase from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { CalendarState } from "@/utils/calendar-state";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { ToolbarService } from "../../services/toolbar-service";
import { MODULE } from "../../config/modules";
import { checkHasModule } from "../../router";
import {CalendarEvent} from "@/models/calendar-event";
import {GoogleCalendarService} from "@/services/google-calendar-service";

export default Vue.extend({
	data() {
		return {
			state: new CalendarState(),
			GoogleCalendarService,
			ready: false,
			selectCalendarOpen: false
		};
	},
	props: {
		toEditEvent: {
			required: false,
			type: Object as () => CalendarEvent
		},
	},
	computed: {
		toolbarItems():ISelectItem<any>[] {
			return [
				{
					text: this.$ct("day-view"),
					value: "setDayView",
					icon: "calendar-day"
				},
				{
					text: this.$ct("week-view"),
					value: "setWeekView",
					icon: "calendar-week"
				},
				{
					text: this.$ct("month-view"),
					value: "setMonthView",
					icon: "calendar-alt"
				},
				{
					text: this.$ct("select-calendars"),
					value: "openSelectCalendars",
					icon: "calendar"
				}
			];
		}
	},
	watch: {
		"GoogleCalendarService.isLoggedIn"() {
			if (this.GoogleCalendarService.isLoggedIn()) {
				this.state.fetchCals();
			}
		}
	},
	methods: {
		trigger(event:string) {
			if (event == "setDayView") {
				this.state.setViewTypeDay();
			} else if (event == "setWeekView") {
				this.state.setViewTypeWeek();
			} else if (event == "setMonthView") {
				this.state.setViewTypeMonth();
			} else if (event == "openSelectCalendars") {
				this.selectCalendarOpen = true;
			}
		}
	},
	async created() {
		if (!checkHasModule(MODULE.AGENDA, this.$router)) {
			throw new Error("MISSING MODULE");
		}
		await this.state.fetchCals();
		this.ready = true;
		ToolbarService.title = this.$ct("calendar");
	},
	components: {
		AppCalendar, // make the <FullCalendar> tag available,
		AppCalendarList,
		AppToolbar,
		AppBase
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
